import { render, staticRenderFns } from "./topupOrder.vue?vue&type=template&id=b31fed52&scoped=true"
import script from "./topupOrder.vue?vue&type=script&lang=ts"
export * from "./topupOrder.vue?vue&type=script&lang=ts"
import style0 from "./topupOrder.vue?vue&type=style&index=0&id=b31fed52&prod&lang=scss"
import style1 from "./topupOrder.vue?vue&type=style&index=1&id=b31fed52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31fed52",
  null
  
)

export default component.exports